import React from 'react';
import PropTypes from 'prop-types';
import FloatingPanel from '../../Panel/FloatingPanel';
import AddBannerForm from './AddBannerForm';
import { getPhotoCurrentUser } from '../../../service/s3Amplify';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../Notification/CustomNotification';
class AddBanner extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      img: '',
      files: [],
      selectedPicture: null,
      urlPreview:'',
      errorMessage:'',
      openNotification : false,
      messageNotification : 'Selecciona un archivo válido',
      typeNotification : "warning"
    };
    this.onDrop = this.onDrop.bind(this);
    this.onClean = this.onClean.bind(this);
  }

  onClean(band){
    if(band){
      this.setState({
        selectedPicture:null,
        urlPreview:'',
        errorMessage:'',
      });
    }else{
      getPhotoCurrentUser(this.props.dataInit.cont_imagePath).then(response =>{
        this.setState({
          urlPreview :response,
          selectedPicture :null
        });
      }).catch(err =>{
        console.log("error url", err);
      });
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.dataInit !== null){
      getPhotoCurrentUser(newProps.dataInit.cont_imagePath).then(response =>{
        console.log(response)
        this.setState({
          urlPreview:response
        });
      }).catch(err =>{
        console.log("error url", err);
      });
    }else{
      this.setState({
        urlPreview: this.state.selectedPicture ? this.state.selectedPicture.preview : ''
      });
    }

    if(!this.props.openForm){
      this.onClean(true);
    }

  }

  onDrop(files) {
    if(files.length===0){
      this.setState({errorMessage:"archivo inválido"});
    }else{
      let oldFiles = this.state.files;
      const filesLimit = 2;
      oldFiles = oldFiles.concat(files);
      if (oldFiles.length > filesLimit) {
        this.setState({
          errorMessage : 'No puedes subir más de un archivo'
        });
      } else {
        this.setState({ img: files[0].preview || '/pic' + files[0].path, selectedPicture: files[0] ,errorMessage:''});        
      }
    }    
  }


  handleCloseNotification = () => {
    this.setState(
      {
        openNotification : false
      }
    )
  }



  render() {
    const {
      openForm,
      closeForm,
      submit,
      action,
      isLoading,
      dataInit
    } = this.props;
    const branch = '';
    return (
      <div>
        <FloatingPanel title={`${action} Banner`} openForm={openForm} branch={branch} closeForm={closeForm}>
          <AddBannerForm
            onDrop={this.onDrop}
            handleSubmit={(event, data)=>submit(event, data, this.state.selectedPicture)}
            preview={this.state.selectedPicture ? this.state.selectedPicture.preview :this.state.urlPreview}
            errorMessage={this.state.errorMessage}
            isLoading={isLoading}
            dataInit={dataInit}
            isOpen={openForm}
            onClean={this.onClean}
          />
        </FloatingPanel>
        <Snackbar
         anchorOrigin={{
             vertical: 'top',
             horizontal: 'right',
         }}
         open={this.state.openNotification}
         autoHideDuration={6000}
         onClose={this.handleCloseNotification}>
       <CustomNotification
         onClose={this.handleCloseNotification}
         variant={this.state.typeNotification}
         message={this.state.messageNotification}/>
       </Snackbar>
      </div>
    );
  }
}

AddBanner.propTypes = {
  classes: PropTypes.object,
  submit: PropTypes.func,
  addContact: PropTypes.func,
  openForm: PropTypes.bool,
  avatarInit: PropTypes.string,
  closeForm: PropTypes.func,
  dataInit:PropTypes.object,
  contentType:PropTypes.string,
  action: PropTypes.string
};

export default (AddBanner);
